import React from 'react';

export class IBM extends React.Component {
  render(){
      return (
        <div className="w3-card w3-animate-bottom full-project-card" id="clapsr">
          <h1>IBM</h1>
          <p>I worked on devices as part of the Healthcare and Life Sciences team at IBM Research for a little over a year.</p>
          <p>Stay tuned for more information as I figure out what info I can share to the world.</p>
          <p>All opinions on here are my own and not IBMs.</p>
        </div>
    );
  }
}
